import { Badge, Box, Text, Icon, Link } from "@chakra-ui/react";
import { Edit, Trash2, QrCode as QrCodeIcon } from "lucide-react";
import {
  TableColumn,
  TableAction,
  ActionHandler,
} from "@/components/section/EntityTableSection";
import { QrCodePixelShare } from "./api";
import { QrCodeAction } from "./hooks/useQrCodeActions";
import RelativeTime from "@/components/ui/RelativeTime";

export const createQrCodeColumns = (): TableColumn<QrCodePixelShare>[] => [
  {
    key: "id",
    title: "ID",
    variant: "id",
  },
  {
    key: "full_name",
    title: "NAME",
    variant: "primary",
  },
  {
    key: "destination_link",
    title: "DESTINATION URL",
    render: (qrCode) => {
      return (
        <Box display="flex" alignItems="center" gap={2}>
          <Icon as={QrCodeIcon} boxSize={4} />
          {qrCode.destination_link ? (
            <Link
              href={qrCode.destination_link}
              target="_blank"
              rel="noopener noreferrer"
              fontSize="xs"
              color="blue.600"
              _dark={{ color: "blue.400" }}
              fontFamily="mono"
              maxW="200px"
              overflow="hidden"
              textOverflow="ellipsis"
              whiteSpace="nowrap"
              _hover={{
                textDecoration: "underline",
                color: "blue.700",
                _dark: { color: "blue.300" }
              }}
            >
              {qrCode.destination_link}
            </Link>
          ) : (
            <Text 
              fontSize="xs" 
              color="gray.600" 
              fontFamily="mono"
              maxW="200px"
              overflow="hidden"
              textOverflow="ellipsis"
              whiteSpace="nowrap"
            >
              No URL
            </Text>
          )}
        </Box>
      );
    },
  },
  {
    key: "key",
    title: "KEY",
  },
  {
    key: "opened",
    title: "OPENED",
    render: (qrCode) => (
      <Badge
        size="sm"
        colorPalette={qrCode.opened ? 'green' : 'gray'}
        variant="subtle"
      >
        {qrCode.opened ? 'Yes' : 'No'}
      </Badge>
    ),
  },
  {
    key: "created",
    title: "CREATED",
    render: (qrCode) => <RelativeTime date={qrCode.created_at} />,
  },
  {
    key: "updated",
    title: "UPDATED",
    render: (qrCode) => (
      <RelativeTime
        date={qrCode.updated_at || qrCode.created_at}
        fallbackDate={qrCode.created_at}
      />
    ),
  },
];

export const createQrCodeActions = (
  onAction: ActionHandler<QrCodePixelShare, QrCodeAction>,
  isLoading: boolean
): TableAction<QrCodePixelShare>[] => [
  {
    key: "edit",
    label: "Edit",
    icon: Edit,
    onClick: (entity) => onAction("edit", entity),
    disabled: isLoading,
  },
  {
    key: "delete",
    label: "Delete",
    icon: Trash2,
    onClick: (entity) => onAction("delete", entity),
    disabled: isLoading,
            colorPalette: "red",
  },
]; 